import FormValidator from './FormValidator';
export default FormValidator;